module.exports = __webpack_public_path__ + "img/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1800dia.41258ac5.png";